import React from "react";
import styles from "./LocationPageHeader.module.css"
import {Button, ButtonState} from "../../../../../elements/button/Button";
import {useAppDispatch} from "../../../../../../app/hooks";
import {FormName, openForm} from "../../../../../elements/formProvider/formSlice";
import {openPopupModal, PopupModalName} from "../../../../../elements/popupModalProvider/popupModalSlice";
import {WarningUi} from "../../../../../../api/generated";
import {WarningBadge} from "../../../../../elements/warningBadge/WarningBadge";

interface LocationPageHeaderProps {
    name: string
    publicId: string
    canBeDeleted: boolean
    warnings: WarningUi[]
}

export const LocationPageHeader: React.FC<LocationPageHeaderProps> = ({
                                                                          name,
                                                                          publicId,
                                                                          canBeDeleted,
                                                                          warnings
                                                                      }) => {
    const dispatch = useAppDispatch()

    const handleEditClick = () => {
        dispatch(openForm({name: FormName.UPDATE_LOCATION, formProps: {publicId}}))
    }

    const handleDeleteClick = () => {
        dispatch(openPopupModal({
            name: PopupModalName.DELETE_LOCATION,
            popupModalProps: {
                publicId,
                entityName: name,
                onClickRedirectPath: "/locations"
            }
        }))
    }

    return <div className={styles.wrapper}>
        <div className={styles.leftGroup}>
            <WarningBadge warnings={warnings}/>
            <span className={styles.name}>{name}</span>
        </div>
        <div className={styles.buttons}>
            <Button
                title={"Edit"}
                iconSrc={"/editIcon.svg"}
                state={ButtonState.SECONDARY}
                handleClick={handleEditClick}
            />
            {canBeDeleted && <Button
                title={"Delete"}
                iconSrc={"/deleteIcon.svg"}
                state={ButtonState.SECONDARY}
                handleClick={handleDeleteClick}
            />}
        </div>
    </div>
}
